// Toggle Navigation
import {gsap} from "gsap";

// Define the GSAP timeline for the animations
const contactNavigation = gsap.utils.toArray('.contact-navigation');

let menuAnimation = gsap.timeline({ paused: true });

contactNavigation.forEach((elem) => {
    menuAnimation.from(elem, {
        y: 32,
        opacity: 0,
        duration: 0.3,
        delay: 1
    });
});

const navToggles = document.querySelectorAll('.js-toggle-menu');

for (let i = 0; i < navToggles.length; i++) {
    navToggles[i].addEventListener('click', function (event) {
        for (let j = 0; j < navToggles.length; j++) {
            event.preventDefault();
            navToggles[j].setAttribute(
                'aria-expanded',
                `${!(navToggles[j].getAttribute('aria-expanded') === 'true')}`
            );
        }

        let subMenus = document.querySelectorAll('.sub-menu');
        subMenus.forEach(function (subMenu) {
            subMenu.classList.remove('show');
        });

        document.body.classList.toggle('menu-open');
            const bodyElem = document.body.classList.contains('menu-open');
            const navigationBackdrop = document.getElementById('navigationBackdrop');
            const header = document.querySelector('.header');

            if (bodyElem) {
                navigationBackdrop.classList.add('show');

                document.querySelectorAll('.main-navigation__list .menu-item a').forEach(elem => elem.addEventListener("mouseenter",
                    () => {
                        elem.parentNode.classList.add('li-is-hovered');
                    }));

                document.querySelectorAll('.main-navigation__list .menu-item a').forEach(elem => elem.addEventListener("mouseleave",
                    () => {
                        elem.parentNode.classList.remove('li-is-hovered');
                    }));

                navigationBackdrop.classList.add('show');
                menuAnimation.play();
            } else {
                navigationBackdrop.classList.remove('show');
                navigationBackdrop.classList.remove('show');
                menuAnimation.reverse();
            }


    });
}

document.querySelector('.navigation-backdrop').addEventListener('click', function (event) {
    event.preventDefault();
    this.setAttribute(
        'aria-expanded',
        `${!(this.getAttribute('aria-expanded') === 'true')}`
    );

    document.body.classList.toggle('menu-open');
    const bodyElem = document.body.classList.contains('menu-open');
    const navigationBackdrop = document.getElementById('navigationBackdrop');
    const header = document.querySelector('.header');

    if (bodyElem) {
        navigationBackdrop.classList.add('show');

        document.querySelectorAll('.main-navigation__list .menu-item a').forEach(elem => elem.addEventListener("mouseenter",
            () => {
                elem.parentNode.classList.add('li-is-hovered');
            }));

        document.querySelectorAll('.main-navigation__list .menu-item a').forEach(elem => elem.addEventListener("mouseleave",
            () => {
                elem.parentNode.classList.remove('li-is-hovered');
            }));
    } else {
        navigationBackdrop.classList.remove('show');
    }
});

jQuery(document).ready(function ($) {

    let _overlays = document.querySelectorAll('.navigation-wrapper');

    Array.prototype.forEach.call(_overlays, function (_overlay) {
        let _clientY = null;
        _overlay.addEventListener('touchstart', function (event) {
            if (event.targetTouches.length === 1) {
                _clientY = event.targetTouches[0].clientY;
            }
        }, false);
        _overlay.addEventListener('touchmove', function (event) {
            if (event.targetTouches.length === 1) {
                disableRubberBand(event);
            }
        }, false);
        function disableRubberBand(event) {
            let clientY = event.targetTouches[0].clientY - _clientY;
            if (_overlay.scrollTop === 0 && clientY > 0) {
                event.preventDefault();
            }
            if (isOverlayTotallyScrolled() && clientY < 0) {
                event.preventDefault();
            }
        }
        function isOverlayTotallyScrolled() {
            return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
        }
    });

});

if (window.innerWidth < 1200) {
    const mobileSubToggles = document.querySelectorAll('.toggle-sub');

    mobileSubToggles.forEach(function (element) {
        element.addEventListener('click', function (e) {
            let nextElement = this.nextElementSibling;
            this.classList.toggle('active');
            nextElement.classList.toggle('show');
        });
    });

    const subBackLink = document.querySelectorAll('.sub-menu__close');


    subBackLink.forEach(function (element) {
        element.addEventListener('click', function (e) {
            let subMenus = document.querySelectorAll('.sub-menu');
            subMenus.forEach(function (subMenu) {
                subMenu.classList.remove('show');
            });
        });
    });
}

if (window.innerWidth < 480) {


    jQuery(document).ready(function ($) {
        $('.lang-switch').appendTo('.contact-navigation');
    });
}
